/**
 * @generated SignedSource<<6e6577d05fc54bdbbfdf909be281389d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PostStatusEnum = "ACF_DISABLED" | "AUTO_DRAFT" | "DRAFT" | "FUTURE" | "HIDDEN" | "HIDDEN_B_S" | "INHERIT" | "PENDING" | "PRIVATE" | "PUBLISH" | "REQUEST_COMPLETED" | "REQUEST_CONFIRMED" | "REQUEST_FAILED" | "REQUEST_PENDING" | "TRASH";
export type ZnglyPostTypeEnum = "Catalog" | "Category" | "CrmList" | "Form" | "FormEntry" | "Hub" | "HubPage" | "MediaItem" | "SiteSettings" | "Znglist";
export type BatchPostMutationInput = {
  clientMutationId?: string | null | undefined;
  ids: ReadonlyArray<string | null | undefined>;
  postType: ZnglyPostTypeEnum;
  status: PostStatusEnum;
};
export type BatchPostMutation_Update_Mutation$variables = {
  input: BatchPostMutationInput;
};
export type BatchPostMutation_Update_Mutation$data = {
  readonly batchPostMutation: {
    readonly ids: ReadonlyArray<string | null | undefined> | null | undefined;
    readonly message: string | null | undefined;
  } | null | undefined;
};
export type BatchPostMutation_Update_Mutation = {
  response: BatchPostMutation_Update_Mutation$data;
  variables: BatchPostMutation_Update_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "BatchPostMutationPayload",
    "kind": "LinkedField",
    "name": "batchPostMutation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ids",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BatchPostMutation_Update_Mutation",
    "selections": (v1/*: any*/),
    "type": "RootMutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BatchPostMutation_Update_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b7a1e809719e494fe81e8f3cd59f744d",
    "id": null,
    "metadata": {},
    "name": "BatchPostMutation_Update_Mutation",
    "operationKind": "mutation",
    "text": "mutation BatchPostMutation_Update_Mutation(\n  $input: BatchPostMutationInput!\n) {\n  batchPostMutation(input: $input) {\n    ids\n    message\n  }\n}\n"
  }
};
})();

(node as any).hash = "9447f286c880ee3c7e149036c657cbea";

export default node;
